import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CompanyCategory, UserCategory } from 'src/app/core/models/core.models';

import { AppState } from 'src/app/reducers';
import { BehaviorSubject, filter, Observable, switchMap, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCompanyCategoryById } from 'src/app/core/reducers';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-post-user-categories-list',
  templateUrl: './post-user-categories-list.component.html',
  styleUrls: ['./post-user-categories-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PostUserCategoriesListComponent {
  private destroyRef = inject(DestroyRef);
  formGroup: FormGroup = new FormGroup({});

  // 1) Subject of incoming IDs
  private companyCategoryId$ = new BehaviorSubject<number | null>(null);

  // 2) Public stream of the selected CompanyCategory
  readonly companyCategory$: Observable<CompanyCategory | null> =
    this.companyCategoryId$.pipe(
      // drop the initial null
      filter((id): id is number => id !== null),
      // re-select every time the ID changes
      switchMap((id) => this.store.select(selectCompanyCategoryById(id))),
    );

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.companyCategory$
      .pipe(
        tap((category) => {
          this.buildCategoryForm(category);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  // 3) Input setter pushes new IDs into the stream
  @Input() set companyCategoryId(id: number) {
    // console.log('companyCategoryId set to', id);
    this.companyCategoryId$.next(id);
  }

  buildCategoryForm(category: CompanyCategory) {
    const group: Record<string, FormControl<boolean>> = {};

    const addCategory = (cat: UserCategory) => {
      group[cat.id] = new FormControl(cat.is_selected);

      cat.children?.forEach(addCategory);
    };

    category.categories.forEach(addCategory);

    return new FormGroup(group);
  }
}
